<script lang="ts">
  import { SubscriptionDisplayService } from '$lib/services/subscription/SubscriptionDisplayService';
  
  export let title: string;
  export let icon: string;
  export let current: number;
  export let limit: number;
  export let isUnlimited: boolean = false;
  export let showProgress: boolean = true;
  
  $: percentage = SubscriptionDisplayService.getUsagePercentage(current, limit);
  $: displayText = SubscriptionDisplayService.formatUsageDisplay(current, limit, isUnlimited);
  $: progressColor = SubscriptionDisplayService.getProgressBarColor(percentage);
  $: isExceeded = !isUnlimited && current >= limit;
</script>

<div class="usage-card" class:exceeded={isExceeded}>
  <div class="usage-header">
    <span class="usage-icon">{icon}</span>
    <span class="usage-title">{title}</span>
  </div>
  <div class="usage-count">
    <span class="current" class:exceeded={isExceeded}>{current}</span>
    <span class="separator">/</span>
    <span class="limit">{isUnlimited ? '무제한' : limit}</span>
  </div>
  {#if showProgress && !isUnlimited}
    <div class="usage-progress">
      <div 
        class="usage-progress-bar {progressColor}"
        style="width: {percentage}%"
      ></div>
    </div>
    <div class="usage-percentage">{percentage}% 사용</div>
  {/if}
</div>

<style>
  .usage-card {
    background: var(--bg-secondary);
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    transition: all 0.15s ease;
  }
  
  .usage-card:hover:not(.exceeded) {
    background: var(--bg-tertiary);
  }
  
  .usage-card.exceeded {
    opacity: 0.6;
    background: var(--bg-tertiary);
  }
  
  .usage-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
  }
  
  .usage-icon {
    font-size: 14px;
    color: var(--text-secondary);
  }
  
  .usage-title {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
  }
  
  .usage-count {
    display: flex;
    align-items: baseline;
    gap: 3px;
    margin-bottom: 8px;
  }
  
  .current {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
  }
  
  .current.exceeded {
    color: var(--error);
  }
  
  .separator {
    font-size: 11px;
    color: var(--text-tertiary);
  }
  
  .limit {
    font-size: 11px;
    font-weight: 400;
    color: var(--text-tertiary);
  }
  
  .usage-progress {
    height: 4px;
    background: var(--bg-primary);
    border-radius: 2px;
    overflow: hidden;
    margin-bottom: 4px;
  }
  
  .usage-progress-bar {
    height: 100%;
    transition: width 0.3s ease;
    border-radius: 2px;
    background: var(--accent-primary);
  }
  
  .usage-progress-bar.success {
    background: var(--success);
  }
  
  .usage-progress-bar.warning {
    background: var(--warning);
  }
  
  .usage-progress-bar.danger {
    background: var(--error);
  }
  
  .usage-percentage {
    font-size: 10px;
    color: var(--text-tertiary);
    text-align: right;
  }
</style>